import { Injectable } from '@angular/core';
import {
	CategoryEnum,
	GlobalKeyEnum,
	I18nItem,
	I18nItems,
	LanguageEnum,
	Translation,
} from '../models/i18n.model';
import { BehaviorSubject, filter, map, Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TranslationDTO } from '../models/callback-on-callnote.model';

@Injectable({
	providedIn: 'root',
})
export class LocalizationService {
	private language: LanguageEnum | undefined;
	private _language$ = new ReplaySubject<LanguageEnum>(1);
	public language$: Observable<LanguageEnum> = this._language$.asObservable();
	private _domain$ = new ReplaySubject<string>(1);
	public domain$: Observable<string> = this._domain$.asObservable();
	// @ts-ignore
	private _translations$ = new BehaviorSubject<I18nItems>(null);
	public get translations$(): Observable<I18nItems> {
		return this._translations$.pipe(filter((x) => !!x));
	}

	constructor() {
		this.setBrandDomain();
	}

	public setTranslations(i18n: TranslationDTO) {
		if (!!i18n[GlobalKeyEnum.CONNECT]) {
			this._translations$.next({
				...i18n[GlobalKeyEnum.CONNECT][CategoryEnum.GENERAL],
				...i18n[GlobalKeyEnum.CONNECT][CategoryEnum.CALLNOTE],
				...i18n[GlobalKeyEnum.CONNECT][CategoryEnum.OUTBOUND_TASK],
				...(i18n[GlobalKeyEnum.CONNECT][CategoryEnum.FEEDBACK] || {}),
				...(i18n[GlobalKeyEnum.CONNECT][CategoryEnum.CALLER_CORRECTION] || {}),
			} as unknown as I18nItems);
		}
	}

	public getTranslationByKey(key: string): string {
		const translations = this._translations$.getValue();
		return this.filterOutTranslationByKey(key, translations);
	}

	public getTranslationByKeyAsync(
		key: string,
		translation$ = this._translations$.asObservable(),
	): Observable<string> {
		return translation$.pipe(
			filter((x) => !!x),
			map((translations) => this.filterOutTranslationByKey(key, translations)),
		);
	}

	private filterOutTranslationByKey(key: string, translations: I18nItems): string {
		return (!!translations && translations[key as I18nItem]?.translation) || '';
	}

	// info not in use atm
	setLanguage(language: string | undefined) {
		this.language = LanguageEnum.EN;
		if (language !== undefined && language.toUpperCase() in LanguageEnum) {
			this.language = LanguageEnum[language.toUpperCase() as keyof typeof LanguageEnum];
		}
		this._language$.next(this.language);
	}

	private setBrandDomain() {
		let tmpDomain = undefined;
		if (location.hostname.includes(environment.URL_SUB_DOMAIN)) {
			tmpDomain = location.hostname.split(`${environment.URL_SUB_DOMAIN}`)[1];
		} else if (!!environment.FALLBACK_DOMAIN) {
			tmpDomain = environment.FALLBACK_DOMAIN;
		}

		if (tmpDomain !== undefined) {
			this._domain$.next(tmpDomain);
		} else {
			console.error('No domain detected.');
		}
	}
}
